import { useState } from 'react';

export default (initialIndex, numberOfItems, scrollToIndex) => {
  const [index, setIndex] = useState(initialIndex);

  const previous = () => {
    const prevIndex = index - 1;

    if (prevIndex >= 0) {
      setIndex(prevIndex);
      scrollToIndex(prevIndex);
    }
  };

  const next = () => {
    const nextIndex = index + 1;

    if (nextIndex < numberOfItems) {
      setIndex(nextIndex);
      scrollToIndex(nextIndex);
    }
  };

  return [index, setIndex, previous, next];
};
